module.exports = __webpack_public_path__ + "img/鞋业“奥斯卡”落户上海CHIC 奥云数据荣获“年度鞋履产业创新者”大奖.4866ac7f.png";